import { ChromelessLayout, PageLayout } from 'src/legacy/components/Layout';
import { PaymentLinkPay } from 'src/routes/payments/payment-links/pay/page';
import { RouteAction } from 'src/routes/types';

const action: RouteAction = () => {
  return {
    chunks: ['payment-links-pay'],
    title: 'Pay Payment Link',
    component: (
      <ChromelessLayout>
        <PageLayout
          fullpage
          routeAccessCheck="allowClientPaymentLinks"
          unauthAccessAllowed="allowClientPaymentLinks"
        >
          <PaymentLinkPay />
        </PageLayout>
      </ChromelessLayout>
    ),
  };
};

export default action;
